import { Judge } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const insertAssignedJudge: (
  fetchContext: FetchContext,
  nominationId: number,
  judge: Judge,
  countryId?: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, judge, countryId, accessToken) => {
  const countryQuery = countryId === undefined ? '' : `?countryId=${countryId}`;

  return fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/judges${countryQuery}`,
  {
    method: 'POST',
    body: JSON.stringify(judge),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'insert assigned judge'));
};
